import * as React from "react"

const BlogVimeoVideo = ({ videoId, width = 640, height = 320 }) => {
  return (
    <iframe
      src={`https://player.vimeo.com/video/${videoId}?title=0&amp;byline=0&amp;portrait=0&amp;color=ec5528`}
      width={width}
      height={height}
      frameborder="0"
      webkitAllowFullScreen
      allowFullScreen
    ></iframe>
  )
}

export default BlogVimeoVideo
